/* eslint-disable @typescript-eslint/restrict-template-expressions */
import UIkit from 'uikit';
import { appendIssueToTitle } from '../components/dialogs/utils';
import { cdcLocations, covidHospLocations, firstDate, firstEpiWeek, fluSurvRegions, fluViewRegions, gftLocations, ghtLocations, nidssDengueLocations, nidssFluLocations, nowcastLocations, quidelLocations, sensorLocations, sensorNames, twitterLocations, wikiArticles, } from '../data/data';
import DataSet, { DataGroup } from '../data/DataSet';
import EpiDate from '../data/EpiDate';
import EpiPoint from '../data/EpiPoint';
import { get } from 'svelte/store';
import { apiKey, expandedDataGroups, storeApiKeys } from '../apiState';
import { isAvailableInV5 } from './v5Availability';
// import DataSet from "../data/DataSet";
// import EpiDate from "../data/EpiDate";
// import EpiPoint from "../data/EpiPoint";
export function epiRange(from, to) {
    return `${from}-${to}`;
}
// find the current epiweek and date
const date = new Date();
const epidate = new EpiDate(date.getFullYear() + 1900, date.getMonth() + 1, date.getDate());
export const currentEpiWeek = epidate.getEpiYear() * 100 + epidate.getEpiWeek();
export const currentDate = epidate.getYear() * 10000 + epidate.getMonth() * 100 + epidate.getDay();
const ENDPOINT = process.env.EPIDATA_ENDPOINT_URL;
const CAST_API_V5_ENDPOINT = process.env.EPIDATA_CAST_API_V5_ENDPOINT_URL;
export const fetchOptions = process.env.NODE_ENV === 'development' ? { cache: 'force-cache' } : {};
function processResponse(response) {
    if (response.ok) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return response.json();
    }
    return response.text().then((text) => {
        throw new Error(`[${response.status}] ${text}`);
    });
}
export function fetchImpl(url) {
    const urlGetS = url.toString();
    if (urlGetS.length < 4096) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fetch(url.toString(), fetchOptions).then((d) => {
            return processResponse(d);
        });
    }
    const params = new URLSearchParams(url.searchParams);
    url.searchParams.forEach((d) => url.searchParams.delete(d));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return fetch(url.toString(), Object.assign(Object.assign({}, fetchOptions), { method: 'POST', body: params })).then((d) => {
        return processResponse(d);
    });
}
function loadEpidata(name, epidata, columns, columnRenamings, params, seriesKey, responseSchema) {
    var _a, _b;
    const datasets = [];
    const colRenamings = new Map(Object.entries(columnRenamings));
    for (const col of columns) {
        const seriesPoints = new Map();
        for (const row of epidata) {
            let date;
            if (responseSchema === 'v4') {
                if (row != null && typeof row.time_value === 'number') {
                    const timeValue = row.time_value;
                    if (timeValue.toString().length == 6) {
                        row.epiweek = timeValue;
                    }
                    else {
                        row.date = timeValue.toString();
                    }
                }
                if (row != null && (typeof row.date === 'string' || typeof row.date === 'number')) {
                    date = EpiDate.parse(row.date.toString());
                }
                else if (row != null && typeof row.epiweek === 'number') {
                    const year = Math.floor(row.epiweek / 100);
                    const week = row.epiweek % 100;
                    date = EpiDate.fromEpiweek(year, week);
                }
                else {
                    throw new Error(`missing date/week column in response`);
                }
            }
            else {
                if (row != null && typeof row.reference_time === 'string') {
                    date = EpiDate.parse(row.reference_time);
                }
                else {
                    throw new Error(`missing reference_time column in response`);
                }
            }
            const key = seriesKey && (row === null || row === void 0 ? void 0 : row[seriesKey]) != null ? String(row[seriesKey]) : '';
            const bucket = (_a = seriesPoints.get(key)) !== null && _a !== void 0 ? _a : [];
            bucket.push(new EpiPoint(date, row[col]));
            seriesPoints.set(key, bucket);
        }
        for (const [key, points] of seriesPoints) {
            points.sort((a, b) => a.getDate().getIndex() - b.getDate().getIndex());
            if (points.length > 0) {
                const base = colRenamings.has(col) ? colRenamings.get(col) : col;
                // An empty renaming means "the series key alone is the name" - used by v5
                // variants whose single `value` column is split into series by `seriesKey`,
                // so their titles match the equivalent v4 column names exactly. In that case
                // the renaming map is consulted a second time, by key, so a v5 variant can
                // also relabel individual signals (e.g. wili -> %wILI).
                const seriesTitle = key ? (base ? `${base} ${key}` : (_b = colRenamings.get(key)) !== null && _b !== void 0 ? _b : key) : base;
                datasets.push(new DataSet(points, seriesTitle, params));
            }
        }
    }
    return new DataGroup(name, datasets);
}
function cleanParams(params) {
    const clean = {};
    Object.entries(params).forEach(([key, value]) => {
        if (value != null && value !== '' && !key.startsWith('_')) {
            clean[key] = value;
        }
    });
    return clean;
}
export function loadDataSet(title, endpoint, fixedParams, userParams, columns, api_key = '', columnRenamings = {}, 
// add additional labels for the error message
additionalLabels = {}, baseUrl = ENDPOINT, apiPath = endpoint, seriesKey, expectedSeriesKeyValues, 
// extra fields stored on the resulting DataSets for display/title purposes only
// (e.g. a human-readable label) - never sent as part of the API request
displayParams = {}, responseSchema = 'v4') {
    const duplicates = get(expandedDataGroups).filter((d) => d.title == title);
    if (duplicates.length > 0) {
        return UIkit.modal
            .alert(`
    <div class="uk-alert uk-alert-error">
      Cannot import duplicate dataset: <b>${title}.</b>
    </div>`)
            .then(() => null);
    }
    let url_string = baseUrl + `/${apiPath}/`;
    if (api_key !== '') {
        url_string += `?api_key=${api_key}`;
    }
    const url = new URL(url_string);
    const params = cleanParams(userParams);
    Object.entries(fixedParams).forEach(([key, value]) => {
        url.searchParams.set(key, String(value));
    });
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, String(value));
    });
    url.searchParams.set('format', 'json');
    return fetchImpl(url)
        .then((res) => {
        try {
            const data = loadEpidata(title, res, columns, columnRenamings, Object.assign(Object.assign({ _endpoint: endpoint }, displayParams), params), seriesKey, responseSchema);
            let missingKeys = [];
            if (seriesKey && expectedSeriesKeyValues && expectedSeriesKeyValues.length > 0) {
                const actualKeys = new Set(res
                    .map((row) => row[seriesKey])
                    .filter((value) => value != null)
                    .map((value) => String(value)));
                missingKeys = expectedSeriesKeyValues.filter((key) => !actualKeys.has(key));
            }
            if (data.datasets.length == 0) {
                return UIkit.modal
                    .alert(`
        <div class="uk-alert uk-alert-error">
          <a href="${url.href}">API Link</a> returned no data for ${additionalLabels.titleLabel}, which suggests that the API has no available information for the selected ${additionalLabels.selectionLabel}${missingKeys.length > 0 ? ` (requested: ${missingKeys.join(', ')})` : ''}.
        </div>`)
                    .then(() => null);
            }
            data.missingSeriesKeyValues = missingKeys;
            return data;
        }
        catch (error) {
            console.warn('failed loading data', error);
            // EpiData API error - JSON with "message" property
            if ('message' in res) {
                const message = res['message'];
                return UIkit.modal
                    .alert(`
          <div class="uk-alert uk-alert-error">
            [f01] Failed to fetch API data from <a href="${url.href}">API Link</a>:<br/><i>${message}</i>
          </div>`)
                    .then(() => null);
            }
            // Fallback for generic error
            return UIkit.modal
                .alert(`
        <div class="uk-alert uk-alert-error">
          [f02] Failed to fetch API data from <a href="${url.href}">API Link</a>:<br/><i>${error}</i>
        </div>`)
                .then(() => null);
        }
    })
        .catch((error) => {
        console.warn('failed fetching data', error);
        return UIkit.modal
            .alert(`
      <div class="uk-alert uk-alert-error">
        [f03] Failed to fetch API data from <a href="${url.href}">API Link</a>:<br/><i>${error}</i>
      </div>`)
            .then(() => null);
    });
}
// Checks v5 metadata for (source, signal) and dispatches to loadDataSet with
// whichever of `v4`/`v5` request shapes matches. The routing decision is
// made once, up front, from cached metadata - never retried based on
// whether the chosen request itself succeeds (see spec's Non-goals).
//
// A null `v5` variant pins the request to v4 regardless of what the metadata
// says. Callers use this for selections v5 cannot express at all - e.g. a
// FluView region with no v5 geo_type equivalent - where source-level
// availability is not enough to decide.
export function loadDataSetWithFallback(title, source, signal, api_key, additionalLabels, v4, v5) {
    return (v5 == null ? Promise.resolve(false) : isAvailableInV5(source, signal)).then((useV5) => {
        var _a, _b, _c;
        const variant = useV5 && v5 != null ? v5 : v4;
        const responseSchema = useV5 ? 'v5' : 'v4';
        return loadDataSet(title, variant.endpoint, variant.fixedParams, variant.userParams, variant.columns, api_key, (_a = variant.columnRenamings) !== null && _a !== void 0 ? _a : {}, additionalLabels, variant.baseUrl, (_b = variant.apiPath) !== null && _b !== void 0 ? _b : variant.endpoint, variant.seriesKey, variant.expectedSeriesKeyValues, (_c = variant.displayParams) !== null && _c !== void 0 ? _c : {}, responseSchema);
    });
}
export function fetchCOVIDcastMeta(api_key) {
    let url_string = ENDPOINT + `/covidcast_meta/`;
    if (api_key !== '') {
        url_string += `?api_key=${api_key}`;
    }
    const url = new URL(url_string);
    url.searchParams.set('format', 'json');
    return fetchImpl(url).catch((error) => {
        console.warn('failed fetching data', error);
        return [];
    });
}
export function fetchPopHiveMeta(api_key) {
    let url_string = CAST_API_V5_ENDPOINT + `/metadata/?source=pophive`;
    if (api_key !== '') {
        url_string += `&token=${api_key}`;
    }
    const url = new URL(url_string);
    return fetchImpl(url).catch((error) => {
        console.warn('failed fetching data', error);
        return {};
    });
}
export function fetchPopHiveExtraKeyValues(api_key) {
    let url_string = CAST_API_V5_ENDPOINT + `/metadata/extra_key_values/?source=pophive`;
    if (api_key !== '') {
        url_string += `&token=${api_key}`;
    }
    const url = new URL(url_string);
    return fetchImpl(url)
        .then((res) => { var _a; return (_a = res.extra_key_values) !== null && _a !== void 0 ? _a : {}; })
        .catch((error) => {
        console.warn('failed fetching extra key values', error);
        return {};
    });
}
export function importPopHive({ signal, geo_type, geo_value, extra_keys, api_key, }) {
    const title = `[API] PopHive: pophive:${signal} (${geo_type}:${geo_value}, ${extra_keys})`;
    if (!api_key && get(storeApiKeys)) {
        api_key = get(apiKey);
    }
    const additionalLabels = {
        titleLabel: 'PopHive (pophive:' + signal + ')',
        selectionLabel: 'location: ' + geo_type + ':' + geo_value,
        dataSourceDocumentationUrl: '',
        dataSourceDescription: 'BETA Cosmos by Pophive provides COVID-19, Influenza, and respiratory syncytial virus (RSV) cases in the emergency Department (ED). This data originates from the Epic Cosmos system.',
    };
    return loadDataSet(title, 'pophive', {}, { source: 'pophive', signal, geo_type, geo_value, extra_keys }, ['value'], api_key, {}, additionalLabels, CAST_API_V5_ENDPOINT, 'viz', undefined, undefined, {}, 'v5').then((ds) => {
        if (ds instanceof DataGroup) {
            ds.defaultEnabled = ['value'];
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function fetchNwssMeta(api_key) {
    let url_string = CAST_API_V5_ENDPOINT + `/metadata/?source=nwss`;
    if (api_key !== '') {
        url_string += `&token=${api_key}`;
    }
    const url = new URL(url_string);
    return fetchImpl(url).catch((error) => {
        console.warn('failed fetching data', error);
        return {};
    });
}
export function importNwss({ signal, geo_type, geo_value, geo_label, extra_keys, fill_method, api_key, }) {
    var _a;
    // extra_keys looks like "nwss_source:CDC_Biobot"; extract the source name so
    // datasets differing only by source get distinct titles
    const nwssSource = extra_keys ? (_a = extra_keys.split(':').pop()) !== null && _a !== void 0 ? _a : '' : '';
    // prefer the county name (geo_label) over the raw, potentially long comma-separated
    // list of sewershed ids in geo_value for the group title/selection label
    const geoDisplay = geo_label || geo_value;
    const title = `[API] NWSS: nwss:${signal} (${geo_type}:${geoDisplay}${nwssSource ? `, ${nwssSource}` : ''})`;
    if (!api_key && get(storeApiKeys)) {
        api_key = get(apiKey);
    }
    const additionalLabels = {
        titleLabel: 'NWSS (nwss:' + signal + ')',
        selectionLabel: 'location: ' + geo_type + ':' + geoDisplay + (nwssSource ? ', source: ' + nwssSource : ''),
        dataSourceDocumentationUrl: '',
        dataSourceDescription: 'BETA The National Wastewater Surveillance System Program (NWSS) is an effort to track infectious deieases through wastewater across the country. This dataset in particular tracks wastewater sample data for COVID-19, mealses, influenza, mpox, rsv, and avian influenza',
    };
    const seriesLabel = `${signal}${nwssSource ? ` (${nwssSource})` : ''}, sewershed:`;
    const expectedSewersheds = geo_value
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
    return loadDataSet(title, 'nwss', {}, { source: 'nwss', signal, geo_type, geo_value, fill_method, extra_keys }, ['value'], api_key, { value: seriesLabel }, additionalLabels, CAST_API_V5_ENDPOINT, 'viz', 'geo_value', // <-- one DataSet per sewershed
    expectedSewersheds, geo_label ? { geo_label } : {}, 'v5').then((ds) => {
        if (ds instanceof DataGroup) {
            ds.defaultEnabled = ds.datasets.filter((d) => d instanceof DataSet).map((d) => d.title);
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
            if (ds.missingSeriesKeyValues.length > 0) {
                const missingIds = ds.missingSeriesKeyValues;
                ds.missingSeriesKeyValues = missingIds.map((id) => `${seriesLabel} ${id} (no data)`);
                void UIkit.modal.alert(`
        <div class="uk-alert uk-alert-warning">
          No data was returned for ${missingIds.length > 1 ? 'sewersheds' : 'sewershed'} <b>${missingIds.join(', ')}</b> (${additionalLabels.titleLabel}, ${additionalLabels.selectionLabel}). The chart includes data for the remaining sewersheds only.
        </div>`);
            }
        }
        return ds;
    });
}
export function importCDC({ locations, auth }) {
    var _a, _b;
    const regionLabel = (_b = (_a = cdcLocations.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const title = `[API] CDC Page Hits: ${regionLabel}`;
    const additionalLabels = {
        titleLabel: 'CDC Page Hist',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/cdc.html',
        dataSourceDescription: 'This data source tracks public interest in influenza by counting visits to specific informational pages on the CDC website. Delphi receives server log summaries directly from the CDC, which count page hits for key topics such as ‘Flu Symptoms & Severity’, ‘How Flu Spreads’, and ‘What To Do If You Get Sick’. These counts act as a proxy for information-seeking behavior related to the flu.',
    };
    return loadDataSet(title, 'cdc', {
        epiweeks: epiRange(firstEpiWeek.cdc, currentEpiWeek),
    }, { locations }, ['total', 'num1', 'num2', 'num3', 'num4', 'num5', 'num6', 'num7', 'num8'], auth, {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
// COVIDcast and v5 disagree about the spelling of a few source names, so the
// `data_source` the dialog works with is not always the `source` v5 knows. Without
// a translation the availability check simply never matches and the source stays on
// v4 forever - a silent non-migration rather than a visible failure, which is why
// this is an explicit table: a new mismatch should be added here deliberately
// rather than papered over with a global hyphen/underscore substitution, which
// would also rewrite the many COVIDcast sources v5 does not carry at all.
const COVIDCAST_V5_SOURCE_ALIASES = {
    'nchs-mortality': 'nchs_mortality',
};
function covidcastV5Source(data_source) {
    var _a;
    return (_a = COVIDCAST_V5_SOURCE_ALIASES[data_source]) !== null && _a !== void 0 ? _a : data_source;
}
export function importCOVIDcast({ data_source, geo_type, geo_value, signal, time_type = 'day', api_key, }) {
    const title = `[API] COVIDcast: ${data_source}:${signal} (${geo_type}:${geo_value})`;
    if (!api_key && get(storeApiKeys)) {
        // if no API key was passed to this method, but we have a saved one, use it...
        // this gets around access control and rate limiting when using an epivis "shared"
        // link (an URL-encoded signal list, processed through `deriveLinkDefaults`).
        api_key = get(apiKey);
    }
    const additionalLabels = {
        titleLabel: 'COVIDcast (' + data_source + ':' + signal + ')',
        selectionLabel: 'location: ' + geo_type + ':' + geo_value,
        dataSourceDocumentationUrl: `https://cmu-delphi.github.io/delphi-epidata/api/covidcast-signals/${data_source}.html`,
        dataSourceDescription: `This dataset provides daily COVID-19 case and hospitalization data sourced from the COVIDcast API. The data is aggregated from multiple sources, including public health labs (ILINet) and clinical labs (WHO_NREVSS), to provide a comprehensive view of COVID-19 activity in the United States.`,
    };
    // Used both to probe v5 availability and as the v5 request's `source`; the two
    // must agree or the check passes and the request then 404s.
    const v5Source = covidcastV5Source(data_source);
    return loadDataSetWithFallback(title, v5Source, signal, api_key, additionalLabels, {
        endpoint: 'covidcast',
        fixedParams: {
            time_type: time_type,
            time_values: time_type === 'day'
                ? epiRange(firstDate.covidcast, currentDate)
                : epiRange(firstEpiWeek.covidcast, currentEpiWeek),
        },
        userParams: { data_source, signal, time_type, geo_type, geo_value },
        columns: ['value', 'stderr', 'sample_size'],
        baseUrl: ENDPOINT,
    }, {
        // `endpoint` must stay 'covidcast' (not 'viz'): it's the key persisted as
        // `params._endpoint` on the resulting DataSet, and `deriveLinkDefaults`'s
        // `lookups` table resolves shared-link re-imports by that key, not by
        // `apiPath`. Using 'viz' here would silently drop this dataset from any
        // shared link, since `lookups.viz` doesn't exist.
        endpoint: 'covidcast',
        apiPath: 'viz',
        fixedParams: {},
        userParams: { source: v5Source, signal, geo_type, geo_value },
        // Persisted alongside the URL params (but never sent as part of the
        // request) so a reloaded shared link has `data_source`/`time_type`
        // available when `importCOVIDcast` re-destructures its arguments. This keeps
        // COVIDcast's spelling, not the aliased v5 one, since that is what the
        // re-import and the dialog's own source list expect.
        displayParams: { data_source, time_type },
        columns: ['value'],
        baseUrl: CAST_API_V5_ENDPOINT,
    }).then((ds) => {
        // get inside the Promise and make sure its not null,
        // then enable display of 'value' data
        if (ds instanceof DataGroup) {
            ds.defaultEnabled = ['value'];
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importCOVIDHosp({ states, issues, }) {
    var _a, _b;
    const regionLabel = (_b = (_a = covidHospLocations.find((d) => d.value === states)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    let title = `[API] COVID Hospitalization: ${regionLabel}`;
    const additionalLabels = {
        titleLabel: 'COVID Hospitalization',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/covid_hosp.html',
        dataSourceDescription: 'This dataset provides daily surveys of hospital COVID-19 capacity and patient impact, as reported by US hospitals. Data is acquired from HealthData.gov. It is a mirror of the “COVID-19 Reported Patient Impact and Hospital Capacity by State Timeseries” and “COVID-19 Reported Patient Impact and Hospital Capacity by State” datasets provided by HHS via healthdata.gov. The latter provides more frequent updates, so it is combined with the former to create a single dataset which is as recent as possible.',
    };
    if (issues != null) {
        title += ` (issued on: ${issues})`;
    }
    else {
        title += ' (most recent issue)';
    }
    return loadDataSet(title, 'covid_hosp_state_timeseries', {
        dates: epiRange(firstDate.covid_hosp, currentDate),
    }, { states, issues }, [
        'hospital_onset_covid',
        'hospital_onset_covid_coverage',
        'inpatient_beds',
        'inpatient_beds_coverage',
        'inpatient_beds_used',
        'inpatient_beds_used_coverage',
        'inpatient_beds_used_covid',
        'inpatient_beds_used_covid_coverage',
        'previous_day_admission_adult_covid_confirmed',
        'previous_day_admission_adult_covid_confirmed_coverage',
        'previous_day_admission_adult_covid_suspected',
        'previous_day_admission_adult_covid_suspected_coverage',
        'previous_day_admission_pediatric_covid_confirmed',
        'previous_day_admission_pediatric_covid_confirmed_coverage',
        'previous_day_admission_pediatric_covid_suspected',
        'previous_day_admission_pediatric_covid_suspected_coverage',
        'staffed_adult_icu_bed_occupancy',
        'staffed_adult_icu_bed_occupancy_coverage',
        'staffed_icu_adult_patients_confirmed_suspected_covid',
        'staffed_icu_adult_patients_confirmed_suspected_covid_coverage',
        'staffed_icu_adult_patients_confirmed_covid',
        'staffed_icu_adult_patients_confirmed_covid_coverage',
        'total_adult_patients_hosp_confirmed_suspected_covid',
        'total_adult_patients_hosp_confirmed_suspected_covid_coverage',
        'total_adult_patients_hosp_confirmed_covid',
        'total_adult_patients_hosp_confirmed_covid_coverage',
        'total_pediatric_patients_hosp_confirmed_suspected_covid',
        'total_pediatric_patients_hosp_confirmed_suspected_covid_coverage',
        'total_pediatric_patients_hosp_confirmed_covid',
        'total_pediatric_patients_hosp_confirmed_covid_coverage',
        'total_staffed_adult_icu_beds',
        'total_staffed_adult_icu_beds_coverage',
        'inpatient_beds_utilization',
        'inpatient_beds_utilization_coverage',
        'inpatient_beds_utilization_numerator',
        'inpatient_beds_utilization_denominator',
        'percent_of_inpatients_with_covid',
        'percent_of_inpatients_with_covid_coverage',
        'percent_of_inpatients_with_covid_numerator',
        'percent_of_inpatients_with_covid_denominator',
        'inpatient_bed_covid_utilization',
        'inpatient_bed_covid_utilization_coverage',
        'inpatient_bed_covid_utilization_numerator',
        'inpatient_bed_covid_utilization_denominator',
        'adult_icu_bed_covid_utilization',
        'adult_icu_bed_covid_utilization_coverage',
        'adult_icu_bed_covid_utilization_numerator',
        'adult_icu_bed_covid_utilization_denominator',
        'adult_icu_bed_utilization',
        'adult_icu_bed_utilization_coverage',
        'adult_icu_bed_utilization_numerator',
        'adult_icu_bed_utilization_denominator',
    ], '', {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
// The FluSurv rate columns. In v4 these are value columns on a single `flusurv`
// row; in v5 they are individual signals under the `flusurv` source, split back
// apart via `seriesKey: 'signal'`. The two lists are identical by design, so both
// routes produce the same series names.
const FLUSURV_RATE_SIGNALS = [
    'rate_age_0',
    'rate_age_0tlt1',
    'rate_age_1',
    'rate_age_12t17',
    'rate_age_18t29',
    'rate_age_1t4',
    'rate_age_2',
    'rate_age_3',
    'rate_age_30t39',
    'rate_age_4',
    'rate_age_40t49',
    'rate_age_5',
    'rate_age_5t11',
    'rate_age_6',
    'rate_age_7',
    'rate_age_gte18',
    'rate_age_gte75',
    'rate_age_lt18',
    'rate_flu_a',
    'rate_flu_b',
    'rate_overall',
    'rate_race_asian',
    'rate_race_black',
    'rate_race_hisp',
    'rate_race_natamer',
    'rate_race_white',
    'rate_sex_female',
    'rate_sex_male',
];
// Signal used to probe v5 availability on behalf of all of FLUSURV_RATE_SIGNALS.
export const FLUSURV_SENTINEL_SIGNAL = 'rate_overall';
// v4 takes a single `locations` value; v5 splits the same set across two geo types.
// The three `network_*` aggregates and the two New York sites are `flusurv_site`;
// everything else is a two-letter state code. v5 spells all of them lowercase.
function fluSurvV5Geo(locations) {
    const isSite = locations.startsWith('network_') || locations.startsWith('NY_');
    return { geo_type: isSite ? 'flusurv_site' : 'state', geo_value: locations.toLowerCase() };
}
function isoDate(date) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getYear()}-${pad(date.getMonth())}-${pad(date.getDay())}`;
}
// v4 expresses "as of" as an epiweek; v5 wants a calendar date. `fromEpiweek`
// returns the Wednesday of the week, so +3 days lands on the Saturday - the end of
// the epiweek, and therefore the cutoff that includes everything published in it.
function issueToSnapshotDate(issues) {
    return isoDate(EpiDate.fromEpiweek(Math.floor(issues / 100), issues % 100).addDays(3));
}
export function importFluSurv({ locations, issues, lag, }) {
    var _a, _b;
    const regionLabel = (_b = (_a = fluSurvRegions.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const additionalLabels = {
        titleLabel: 'FluSurv',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/flusurv.html',
        dataSourceDescription: 'This data source provides laboratory-confirmed influenza hospitalization rates from the CDC’s Influenza Hospitalization Surveillance Network (FluSurv-NET). The data includes age-stratified hospitalization rates and rates by race, sex, and flu type, when available.',
    };
    // Resolved here as well as inside loadDataSetWithFallback so the title can reflect
    // the route taken. Both calls share getV5Metadata's cached promise, so this costs
    // no extra request and the two decisions cannot disagree.
    return isAvailableInV5('flusurv', FLUSURV_SENTINEL_SIGNAL)
        .then((useV5) => {
        // v5 has no publication-lag concept. Rather than serve a lagged request from
        // v4 - which is frozen, so its series would be quietly incomparable to live v5
        // ones on the same chart - lag is dropped whenever v5 is serving this source.
        // FluSurv.svelte hides the lag control in that case; this covers shared links
        // created before it was hidden.
        const effectiveLag = useV5 ? null : lag;
        const title = appendIssueToTitle(`[API] FluSurv: ${regionLabel}`, { issues, lag: effectiveLag });
        return loadDataSetWithFallback(title, 'flusurv', FLUSURV_SENTINEL_SIGNAL, '', additionalLabels, {
            endpoint: 'flusurv',
            fixedParams: {
                epiweeks: epiRange(firstEpiWeek.flusurv, currentEpiWeek),
            },
            userParams: { locations, issues, lag },
            columns: FLUSURV_RATE_SIGNALS,
            baseUrl: ENDPOINT,
        }, {
            // `endpoint` stays 'flusurv': it is the key persisted as `params._endpoint`
            // and the one `deriveLinkDefaults`'s `lookups` table resolves shared-link
            // re-imports by. The URL path is 'viz' (see apiPath).
            endpoint: 'flusurv',
            apiPath: 'viz',
            fixedParams: {},
            userParams: Object.assign(Object.assign({ source: 'flusurv', signal: FLUSURV_RATE_SIGNALS.join(',') }, fluSurvV5Geo(locations)), { 
                // cleanParams drops this when no issue is selected.
                snapshot_date: issues != null ? issueToSnapshotDate(issues) : null }),
            // v5 returns one `value` column tagged by `signal`; the empty renaming makes
            // each series take its signal name alone, matching the v4 column names.
            columns: ['value'],
            columnRenamings: { value: '' },
            seriesKey: 'signal',
            // Deliberately no expectedSeriesKeyValues: most locations carry only a
            // subset of the 28 signals, and listing the rest as "(no data)" in the tree
            // would be noise. v4 simply omits empty columns; this matches.
            // Persisted alongside the URL params (but never sent) so a reloaded shared
            // link still has `locations` and `issues` when importFluSurv re-destructures
            // its arguments - neither appears in the v5 request itself. `lag` is
            // intentionally absent; it no longer applies on this route.
            displayParams: { locations, issues },
            baseUrl: CAST_API_V5_ENDPOINT,
        });
    })
        .then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
// v5 signal names for ILINet. These deliberately keep v5's own spelling for the
// age buckets (num_ili_age_0_4 and friends) rather than remapping them onto v4's
// opaque num_age_0..5 indices: the v5 names state the age range outright, and an
// incorrect index mapping would mislabel a series with no visible symptom.
const FLUVIEW_ILINET_SIGNALS = [
    'wili',
    'ili',
    'num_ili',
    'num_patients',
    'num_providers',
    'num_ili_age_0_4',
    'num_ili_age_5_24',
    'num_ili_age_25_49',
    'num_ili_age_25_64',
    'num_ili_age_50_64',
    'num_ili_age_65',
];
// Signal used to probe v5 availability on behalf of all of FLUVIEW_ILINET_SIGNALS.
export const FLUVIEW_SENTINEL_SIGNAL = 'wili';
// v4 names every FluView region in one flat `regions` namespace; v5 splits them
// across four geo types. Returns null for the regions v5 has no equivalent for at
// all - `ny_minus_jfk`, the five territories and the three cities - which pins
// those selections to v4 (see loadDataSetWithFallback's null `v5` variant).
//
// Case carries meaning in the v4 list and is what separates the groups here:
// states are the only uppercase two-letter values, territories are lowercase.
export function fluViewV5Geo(regions) {
    if (regions === 'nat') {
        return { geo_type: 'nation', geo_value: 'us' };
    }
    const hhs = /^hhs(\d{1,2})$/.exec(regions);
    if (hhs) {
        return { geo_type: 'hhs', geo_value: hhs[1] };
    }
    const census = /^cen(\d)$/.exec(regions);
    if (census) {
        return { geo_type: 'census_division', geo_value: census[1] };
    }
    if (/^[A-Z]{2}$/.test(regions)) {
        return { geo_type: 'state', geo_value: regions.toLowerCase() };
    }
    return null;
}
export function importFluView({ regions, issues, lag, auth, }) {
    var _a, _b;
    const regionLabel = (_b = (_a = fluViewRegions.find((d) => d.value === regions)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const additionalLabels = {
        titleLabel: 'ILINet (aka FluView)',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/fluview.html',
        dataSourceDescription: 'The fluview endpoint reports influenza-like illness (ILI) data sourced from the U.S. Outpatient Influenza-like Illness Surveillance Network (ILINet) dashboard. Data is sourced from both ILINet (public health labs) and WHO_NREVSS (clinical labs).',
    };
    const v5Geo = fluViewV5Geo(regions);
    // Resolved here as well as inside loadDataSetWithFallback so the title, the lag
    // handling and the auth token can all reflect the route taken. Both calls share
    // getV5Metadata's cached promise, so this costs no extra request.
    return (v5Geo == null ? Promise.resolve(false) : isAvailableInV5('fluview_ilinet', FLUVIEW_SENTINEL_SIGNAL))
        .then((useV5) => {
        // v5 has no publication-lag concept - see importFluSurv.
        const effectiveLag = useV5 ? null : lag;
        const title = appendIssueToTitle(`[API] ILINet (aka FluView): ${regionLabel}`, { issues, lag: effectiveLag });
        return loadDataSetWithFallback(title, 'fluview_ilinet', FLUVIEW_SENTINEL_SIGNAL, 
        // `auth` is a v4 credential and v5's /viz/ declares no such parameter, so it
        // is not forwarded to the v5 host.
        useV5 ? '' : auth !== null && auth !== void 0 ? auth : '', additionalLabels, {
            endpoint: 'fluview',
            fixedParams: {
                epiweeks: epiRange(firstEpiWeek.fluview, currentEpiWeek),
            },
            userParams: { regions, issues, lag },
            columns: [
                'wili',
                'ili',
                'num_ili',
                'num_patients',
                'num_providers',
                'num_age_0',
                'num_age_1',
                'num_age_2',
                'num_age_3',
                'num_age_4',
                'num_age_5',
            ],
            columnRenamings: {
                wili: '%wILI',
                ili: '%ILI',
            },
            baseUrl: ENDPOINT,
        }, v5Geo == null
            ? null
            : {
                // `endpoint` stays 'fluview': it is the key persisted as
                // `params._endpoint` and the one `deriveLinkDefaults`'s `lookups` table
                // resolves shared-link re-imports by. The URL path is 'viz'.
                endpoint: 'fluview',
                apiPath: 'viz',
                fixedParams: {},
                userParams: Object.assign(Object.assign({ source: 'fluview_ilinet', signal: FLUVIEW_ILINET_SIGNALS.join(',') }, v5Geo), { snapshot_date: issues != null ? issueToSnapshotDate(issues) : null }),
                columns: ['value'],
                // Empty renaming for the column, so each series is named by its signal;
                // the two percentage signals keep the v4 display names so `defaultEnabled`
                // and shared-link title matching survive a v4/v5 switch.
                columnRenamings: { value: '', wili: '%wILI', ili: '%ILI' },
                seriesKey: 'signal',
                displayParams: { regions, issues },
                baseUrl: CAST_API_V5_ENDPOINT,
            });
    })
        .then((ds) => {
        // get inside the Promise and make sure its not null,
        // then enable display of 'percent weighted ILI' data
        if (ds instanceof DataGroup) {
            ds.defaultEnabled = ['%wILI'];
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
// v5 signal names for the clinical-labs series, paired with the v4 column name each
// one carries. The correspondence was confirmed against live data rather than
// inferred from the names: for nat/201740-201742 every v4 column equals its v5
// signal exactly (e.g. total_a 230 == positive_a 230). Renaming them back to the v4
// spellings keeps both routes producing the same series names, which is what lets
// `defaultEnabled` and shared-link title matching survive a v4/v5 switch.
const FLUVIEW_CLINICAL_V5_TO_V4 = {
    total_specimens: 'total_specimens',
    positive_a: 'total_a',
    positive_b: 'total_b',
    pct_positive: 'percent_positive',
    pct_positive_a: 'percent_a',
    pct_positive_b: 'percent_b',
};
// Signal used to probe v5 availability on behalf of all of the clinical signals.
export const FLUVIEW_CLINICAL_SENTINEL_SIGNAL = 'pct_positive';
export function importFluViewClinical({ regions, issues, lag, }) {
    var _a, _b;
    const regionLabel = (_b = (_a = fluViewRegions.find((d) => d.value === regions)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const additionalLabels = {
        titleLabel: 'FluView Clinical',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/fluview_clinical.html',
        dataSourceDescription: 'This data source provides age-stratified clinical data based on laboratory-confirmed influenza reports from the US FluView dashboard.',
    };
    // Same region namespace as ILINet, so the same geo mapping and the same v4-only
    // regions apply (see fluViewV5Geo).
    const v5Geo = fluViewV5Geo(regions);
    return (v5Geo == null
        ? Promise.resolve(false)
        : isAvailableInV5('fluview_resp_lab_clinical', FLUVIEW_CLINICAL_SENTINEL_SIGNAL))
        .then((useV5) => {
        // v5 has no publication-lag concept - see importFluSurv.
        const effectiveLag = useV5 ? null : lag;
        const title = appendIssueToTitle(`[API] FluView Clinical: ${regionLabel}`, { issues, lag: effectiveLag });
        return loadDataSetWithFallback(title, 'fluview_resp_lab_clinical', FLUVIEW_CLINICAL_SENTINEL_SIGNAL, '', additionalLabels, {
            endpoint: 'fluview_clinical',
            fixedParams: {
                epiweeks: epiRange(firstEpiWeek.fluview, currentEpiWeek),
            },
            userParams: { regions, issues, lag },
            columns: ['total_specimens', 'total_a', 'total_b', 'percent_positive', 'percent_a', 'percent_b'],
            baseUrl: ENDPOINT,
        }, v5Geo == null
            ? null
            : {
                // `endpoint` stays 'fluview_clinical': it is the key persisted as
                // `params._endpoint` and the one `deriveLinkDefaults`'s `lookups` table
                // resolves shared-link re-imports by. The URL path is 'viz'.
                endpoint: 'fluview_clinical',
                apiPath: 'viz',
                fixedParams: {},
                userParams: Object.assign(Object.assign({ source: 'fluview_resp_lab_clinical', signal: Object.keys(FLUVIEW_CLINICAL_V5_TO_V4).join(',') }, v5Geo), { snapshot_date: issues != null ? issueToSnapshotDate(issues) : null }),
                columns: ['value'],
                // Empty renaming for the column, so each series is named by its signal,
                // then each signal is relabelled to its v4 equivalent.
                columnRenamings: Object.assign({ value: '' }, FLUVIEW_CLINICAL_V5_TO_V4),
                seriesKey: 'signal',
                displayParams: { regions, issues },
                baseUrl: CAST_API_V5_ENDPOINT,
            });
    })
        .then((ds) => {
        // get inside the Promise and make sure its not null,
        // then enable display of 'percent_positive' data
        if (ds instanceof DataGroup) {
            ds.defaultEnabled = ['percent_positive'];
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importGFT({ locations }) {
    var _a, _b;
    const regionLabel = (_b = (_a = gftLocations.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const title = `[API] GFT: ${regionLabel}`;
    const additionalLabels = {
        titleLabel: 'GFT',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/gft.html',
        dataSourceDescription: 'This data source provides a historical estimate of influenza activity based on the aggregated volume of search queries related to flu symptoms, treatments, and related topics. The data is sourced from Google Flu Trends (GFT), which used these query volumes to model ILI rates.',
    };
    return loadDataSet(title, 'gft', {
        epiweeks: epiRange(firstEpiWeek.gft, currentEpiWeek),
    }, { locations }, ['num'], '', {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importGHT({ auth, locations, query, }) {
    var _a, _b;
    const regionLabel = (_b = (_a = ghtLocations.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const title = `[API] GHT: ${regionLabel} [${query}]`;
    const additionalLabels = {
        titleLabel: 'GHT',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/ght.html',
        dataSourceDescription: 'The ght endpoint provides access to Google Health Trends data, which tracks the aggregated volume of search queries related to specific influenza symptoms and treatments.',
    };
    return loadDataSet(title, 'ght', {
        epiweeks: epiRange(firstEpiWeek.ght, currentEpiWeek),
    }, { locations, query }, ['value'], auth, {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importNIDSSDengue({ locations }) {
    var _a, _b;
    const regionLabel = (_b = (_a = nidssDengueLocations.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const title = `[API] NIDSS-Dengue: ${regionLabel}`;
    const additionalLabels = {
        titleLabel: 'NIDSS-Dengue',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/nidss_dengue.html',
        dataSourceDescription: 'This endpoint reports counts of confirmed dengue cases from the Taiwan National Infectious Disease Statistics System (NIDSS) via the Taiwan CDC.',
    };
    return loadDataSet(title, 'nidss_dengue', {
        epiweeks: epiRange(firstEpiWeek.nidss_dengue, currentEpiWeek),
    }, { locations }, ['count'], '', {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importNIDSSFlu({ regions, issues, lag, }) {
    var _a, _b;
    const regionLabel = (_b = (_a = nidssFluLocations.find((d) => d.value === regions)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const title = appendIssueToTitle(`[API] NIDSS-influenza: ${regionLabel}`, { issues, lag });
    const additionalLabels = {
        titleLabel: 'NIDSS-influenza',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/nidss_flu.html',
        dataSourceDescription: 'This endpoint provides weekly influenza case counts for Taiwan, as reported by the Taiwan National Infectious Disease Statistics System (NIDSS) via the Taiwan CDC.',
    };
    return loadDataSet(title, 'nidss_flu', {
        epiweeks: epiRange(firstEpiWeek.nidss_flu, currentEpiWeek),
    }, { regions, issues, lag }, ['visits', 'ili'], '', {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importNowcast({ locations }) {
    var _a, _b;
    const regionLabel = (_b = (_a = nowcastLocations.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const title = `[API] Delphi Nowcast: ${regionLabel}`;
    const additionalLabels = {
        titleLabel: 'Delphi Nowcast',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/nowcast.html',
        dataSourceDescription: 'This endpoint provides Delphi’s nowcast estimates of the percentage of outpatient visits due to Influenza-Like Illness (ILI).',
    };
    return loadDataSet(title, 'nowcast', {
        epiweeks: epiRange(firstEpiWeek.nowcast, currentEpiWeek),
    }, { locations }, ['value', 'std'], '', {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importQuidel({ auth, locations }) {
    var _a, _b;
    const regionLabel = (_b = (_a = quidelLocations.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const title = `[API] Quidel Data: ${regionLabel}`;
    const additionalLabels = {
        titleLabel: 'Quidel Data',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/quidel.html',
        dataSourceDescription: 'This data source provides influenza testing data from Quidel Corporation, covering HHS health regions. Data is aggregated by unique device. Covers US states (excluding some like FL in older mappings).',
    };
    return loadDataSet(title, 'quidel', {
        epiweeks: epiRange(firstEpiWeek.quidel, currentEpiWeek),
    }, { locations }, ['value'], auth, {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importSensors({ auth, names, locations, }) {
    var _a, _b, _c, _d;
    const regionLabel = (_b = (_a = sensorLocations.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const namesLabel = (_d = (_c = sensorNames.find((d) => d.value === names)) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : '?';
    const title = `[API] Delphi Sensor: ${namesLabel}: ${regionLabel}`;
    const additionalLabels = {
        titleLabel: 'Delphi Sensor (' + namesLabel + ')',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/sensors.html',
        dataSourceDescription: 'This endpoint provides access to Delphi’s digital surveillance sensor estimates for seasonal influenza-like illness (ILI). It aggregates signals from multiple digital sources, including Google Health Trends, Wikipedia access counts, Twitter posts, and CDC web traffic, to provide real-time indicators of flu activity before official clinical reports are finalized.',
    };
    return loadDataSet(title, 'sensors', {
        epiweeks: epiRange(firstEpiWeek.sensors, currentEpiWeek),
    }, { names, locations }, ['value'], auth, {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
// twtr
export function importTwitter({ auth, locations, resolution, }) {
    var _a, _b;
    const regionLabel = (_b = (_a = twitterLocations.find((d) => d.value === locations)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    const title = `[API] Twitter: ${regionLabel}, ${resolution[0].toUpperCase()}${resolution.slice(1)}`;
    const additionalLabels = {
        titleLabel: 'Twitter',
        selectionLabel: 'location: ' + regionLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/twitter.html',
        dataSourceDescription: 'This data source provides estimates of influenza activity derived from the content of public Twitter posts. The data was processed by HealthTweets.org using natural language processing (NLP) to classify tweets as flu-related.',
    };
    return loadDataSet(title, 'twitter', resolution === 'daily'
        ? {
            dates: epiRange(firstDate.twitter, currentDate),
        }
        : {
            epiweeks: epiRange(firstEpiWeek.twitter, currentEpiWeek),
        }, { locations, resolution }, ['num', 'total', 'percent'], auth, {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function importWiki({ articles, resolution, hour, language = 'en', }) {
    var _a, _b;
    const articleLabel = (_b = (_a = wikiArticles.find((d) => d.value === articles)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '?';
    let title = `[API] Wiki: ${articleLabel}, ${resolution[0].toUpperCase()}${resolution.slice(1)}`;
    const additionalLabels = {
        titleLabel: 'Wiki',
        selectionLabel: 'article: ' + articleLabel,
        dataSourceDocumentationUrl: 'https://cmu-delphi.github.io/delphi-epidata/api/wiki.html',
        dataSourceDescription: 'This data source measures public interest in health topics by tracking access counts for specific influenza-related articles on English-language Wikipedia. Delphi aggregates these counts from Wikimedia’s public pageview dumps, providing a proxy for information-seeking behavior and public awareness of the flu.',
    };
    if (hour != null) {
        title += ` (${hour})`;
    }
    return loadDataSet(title, 'wiki', resolution === 'daily'
        ? {
            dates: epiRange(firstDate.wiki, currentDate),
        }
        : {
            epiweeks: epiRange(firstEpiWeek.wiki, currentEpiWeek),
        }, { articles, hour, language, resolution }, ['count', 'total', 'value'], '', {}, additionalLabels).then((ds) => {
        if (ds instanceof DataGroup) {
            ds.dataSourceDocumentationUrl = additionalLabels.dataSourceDocumentationUrl;
            ds.dataSourceDescription = additionalLabels.dataSourceDescription;
        }
        return ds;
    });
}
export function fetchNWSSGeoValues(api_key) {
    const url = new URL(CAST_API_V5_ENDPOINT + '/geomap/nwss_sewershed_crosswalk/?other_geo_type=county');
    if (api_key !== '') {
        url.searchParams.set('token', api_key);
    }
    return fetch(url.toString())
        .then((response) => {
        if (!response.ok)
            throw new Error(`HTTP error! status: ${response.status}`);
        return response.text();
    })
        .then((text) => {
        var _a, _b, _c, _d;
        const rows = text.trim().split(/\r?\n/);
        if (rows.length < 2)
            return [];
        const header = rows[0].split(',').map((h) => h.trim());
        const fromIdx = header.indexOf('from_val');
        const toIdx = header.indexOf('to_val');
        const toNameIdx = header.indexOf('to_name');
        const byCounty = new Map();
        for (let i = 1; i < rows.length; i++) {
            const cols = rows[i].split(',');
            const sewershedId = (_a = cols[fromIdx]) === null || _a === void 0 ? void 0 : _a.trim();
            const countyFips = (_b = cols[toIdx]) === null || _b === void 0 ? void 0 : _b.trim();
            const countyName = (_c = cols[toNameIdx]) === null || _c === void 0 ? void 0 : _c.trim();
            if (!sewershedId || !countyFips || !countyName)
                continue;
            const entry = (_d = byCounty.get(countyFips)) !== null && _d !== void 0 ? _d : { name: countyName || countyFips, sewersheds: [] };
            entry.sewersheds.push(sewershedId);
            byCounty.set(countyFips, entry);
        }
        return [...byCounty.values()].map((e) => ({ county: e.name, sewersheds: e.sewersheds }));
    })
        .catch((error) => {
        console.error('Error fetching NWSS geo values:', error);
        return [];
    });
}
